/**
 * Канонические URL обзора каталога: /catalog/:categoryId/:sectionSlug
 * (не пересекаются с /solutions/:vendorSlug и /solutions/:vendor/:product).
 */

export function catalogCategoryPath(categoryId) {
  if (!categoryId || categoryId === 'all') return '/solutions';
  return `/catalog/${encodeURIComponent(categoryId)}`;
}

export function catalogCategorySectionPath(categoryId, sectionSlug) {
  if (!categoryId || categoryId === 'all') return '/solutions';
  if (!sectionSlug || sectionSlug === 'all') {
    return catalogCategoryPath(categoryId);
  }
  return `/catalog/${encodeURIComponent(categoryId)}/${encodeURIComponent(sectionSlug)}`;
}

/** Зарезервированный slug для решений без раздела в URL. */
export const CATALOG_SECTION_NONE_SLUG = 'none';

/** Slug раздела для URL из записи реестра или отображаемого имени. */
export function sectionSlugForNavigation(sectionName, sectionRecord) {
  if (sectionRecord?.slug) return sectionRecord.slug;
  if (sectionName === 'Без раздела') return CATALOG_SECTION_NONE_SLUG;
  return '';
}

export function catalogVendorPath(
  vendorSlug,
  { categoryId, sectionName, situationId } = {},
) {
  if (!vendorSlug) return '/solutions';
  const base = `/solutions/${encodeURIComponent(vendorSlug)}`;
  const params = new URLSearchParams();
  if (categoryId && categoryId !== 'all') params.set('category', categoryId);
  if (sectionName && sectionName !== 'all') params.set('section', sectionName);
  if (situationId) params.set('situation', situationId);
  const q = params.toString();
  return q ? `${base}?${q}` : base;
}

export function catalogSolutionPath(
  vendorSlug,
  solutionId,
  { categoryId, sectionName, situationId } = {},
) {
  if (!vendorSlug || !solutionId) return '/solutions';
  const base = `/solutions/${encodeURIComponent(vendorSlug)}/${encodeURIComponent(solutionId)}`;
  const params = new URLSearchParams();
  if (categoryId && categoryId !== 'all') params.set('category', categoryId);
  if (sectionName && sectionName !== 'all') params.set('section', sectionName);
  if (situationId) params.set('situation', situationId);
  const q = params.toString();
  return q ? `${base}?${q}` : base;
}
